require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./careers-project-manager-uk.json") })
        }
      }, "path---careers-project-manager-uk");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---careers-project-manager-uk!./.cache/json/careers-project-manager-uk.json
// module id = 874
// module chunks = 231608221292675